import React, { Component } from 'react';
import axios from 'axios';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext';
import Swal from 'sweetalert2';
import ReactApexChart from 'react-apexcharts';
import { TextBox, formatDate } from "../../Components/InputElements";
import Select from 'react-select';
import { decodeData } from '../../Constants/constants';


class Leaveapply extends Component {
    static contextType = ConfigContext;

    constructor(props) {
        super(props);
        this.state = {
            employee_id: props.params.employee_id,
            employee_leave_id: '',
            leave_type_id: '',
            filter_leave_type_id: '',
            leave_category_id: '',
            employee_leave_from_date: '',
            from_date: '',
            to_date: '',
            employee_leave_to_date: '',
            employee_leave_document: '',
            employee_leave_reason: '',
            employee_leave_to_day_unit: '',
            employee_leave_from_day_unit: '',
            required_document: 0,
            leave_loader: false,
            employee_leave_status: '',
            fileName: "",
            fileSize: "",
            past_date: 0,
            half_day: 0,
            selectedImage: null,
            loadingList: false,
            postLoading: false,
            leave_type_row: [],
            leave_log_rows: [],
            errors: {},
            errorMessage: '',
            check_modal_type: '',
            next: false,
            prev: false,
            LeaveRows: [],
            get_url: '',
            total_records: 0,
            total_pages: 0,
            rows: [],
            employee_info: [],
            submitAttempted: false,
            salaries: [],
            salaries_statutory: [],
            decodedData: [],
            casualseries: [50],
            casualoptions: {
                chart: {
                    height: 350,
                    type: 'radialBar',
                },
                plotOptions: {
                    radialBar: {
                        hollow: {
                            size: '70%',
                        }
                    },
                },
                labels: ['Leaves'],
                colors: ['#4caf50']
            },

        };
        this.modalRef = React.createRef();
        this.closeRef = React.createRef();
    }

    componentDidMount() {
        this.setState({ loadingList: true }, () => {
            this.GetList();
            this.GetLeaveTypeList();
            this.GetRemmainingLeaves();
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
          // console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
              const queryParams = new URLSearchParams(window.location.search);
              const encodedData = queryParams.get("abs");
              const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
              if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({ decodedData });
              }
            } else {
              console.warn("Permissions not yet available. Retrying...");
            }
        }
      }
      
    validateNotEmpty = (fieldName, value) => {
        if (value === undefined || value === null) {
            return `${fieldName} is required`;
        }
        if (typeof value !== 'string') {
            value = String(value); 
        }
        if (value.trim() === '') {
            return `${fieldName} is required`;
        }
        return '';
    }
    validateDate = (fieldName, value_to, value_from) => {
        const date = new Date(value_to);
        const today = new Date(value_from);
        if (date < today) {
            return `Please Select Future Date For ${fieldName}....!!`;
        }
        return '';
    }
    GetLeaveTypeList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Employees/GetLeaveTypeList`, { headers })
            .then((response) => {

                var data = response.data;
                if (response.data.success === true) {
                    this.setState((prevState) => ({
                        leave_type_row: data.data.map((row) => ({
                            value: row.leave_type_id,
                            label: row.leave_type_name
                        }))
                    }));
                }
            });
    }

    GetLeaveTypeInfo = (leave_type_id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Employees/GetLeaveTypeInfo`, { params: { leave_type_id: leave_type_id, employee_id: this.state.employee_id }, headers }).then((response) => {
            var data = response.data.data;
            if (response.data.success === true) {
                this.setState({
                    required_document: data[0].required_document,
                    past_date: data[0].past_date,
                    half_day: data[0].half_day,
                    loadingList: false,
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Employees/GetApplyLeaves`, {
            params:
            {
                employee_leave_status: this.state.employee_leave_status,
                leave_type_id: this.state.filter_leave_type_id,
                from_date: this.state.from_date,
                to_date: this.state.to_date,
                employee_id: this.state.employee_id,
            }, headers
        }).then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }
    GetRemmainingLeaves = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Employees/GetRemainingLeaves`, {params:{employee_id:this.state.employee_id} ,headers }).then((response) => {
            var data = response.data;

            if (response.data.success === true) {
                this.setState({
                    LeaveRows: data.data,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    GetLeaveLogs = (employee_leave_id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Employees/GetLeaveLogs`, { params: { employee_leave_id: employee_leave_id, employee_id: this.state.employee_id }, headers }).then((response) => {
            var data = response.data;
            this.setState({ leave_log_rows: [] });
            if (response.data.success === true) {
                this.setState({
                    leave_log_rows: data.data,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    handleDelete = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You Want To Cancel Apply Leave...?",
                icon: 'warning',
                showCancelButton: true,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes !!',
                cancelButtonText: 'No'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true });
                const formData = {
                    employee_leave_id: id,
                    employee_id: this.state.employee_id,
                };
                axios
                    .post(`${apiURL}Employees/CancelApplyLeave`, formData, { headers })
                    .then((response) => {
                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            timer: 1000,
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        });
                        this.setState({ status: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetList();
                                this.GetRemmainingLeaves();
                            })
                        }
                    })
                    .catch((error) => {

                        Swal.fire({
                            title: <strong>Error</strong>,
                            html: error,
                            icon: 'error'
                        })
                    });
            }
        });
    }

    CheckValidation = () => {
        const errors = {};
        const { employee_leave_from_date, employee_leave_to_date, employee_leave_reason, leave_type_id, employee_leave_from_day_unit, employee_leave_to_day_unit } = this.state;
        errors.employee_leave_from_date = this.validateNotEmpty('From Date', employee_leave_from_date);
        errors.employee_leave_to_date = this.validateNotEmpty('To Date', employee_leave_to_date) || this.validateDate('To Date', employee_leave_to_date, employee_leave_from_date);
        errors.employee_leave_reason = this.validateNotEmpty('Reason', employee_leave_reason);
        errors.leave_type_id = this.validateNotEmpty('Leave Type', leave_type_id);
        errors.employee_leave_from_day_unit = this.validateNotEmpty('From Date Unit', employee_leave_from_day_unit);
        errors.employee_leave_to_day_unit = this.validateNotEmpty('To Date Unit', employee_leave_to_day_unit);

        if (employee_leave_from_date === employee_leave_to_date &&
            employee_leave_from_day_unit !== employee_leave_to_day_unit) {
            errors.employee_leave_to_day_unit = 'Please select the same unit';
        }


        return errors;
    }

    handleSubmit = (isUpdate) => {
        const errors = this.CheckValidation();
        this.setState({ errors, submitAttempted: true, leave_loader: true }, () => {
            // If there are no errors, submit the form
            if (Object.values(errors).every(error => error === '')) {
                // Your form submission logic here
                const fileInput = document.getElementById("employee_leave_document");
                const file = fileInput.files[0];
                const formData = new FormData();

                // Always append these fields
                formData.append("employee_id", this.state.employee_id);
                formData.append("leave_type_id", this.state.leave_type_id);
                formData.append("employee_leave_from_date", this.state.employee_leave_from_date);
                formData.append("employee_leave_to_date", this.state.employee_leave_to_date);
                formData.append("employee_leave_reason", this.state.employee_leave_reason);
                formData.append("employee_leave_to_day_unit", this.state.employee_leave_to_day_unit);
                formData.append("employee_leave_from_day_unit", this.state.employee_leave_from_day_unit);
                formData.append("required_document", this.state.required_document);

                if (isUpdate === true) {
                    formData.append("employee_leave_id", this.state.employee_leave_id);
                }
                if (file) {
                    formData.append("employee_leave_document", file);
                }

                var headers = this.context.apiHeaderFile;
                const { apiURL } = this.context;
                axios.post(`${apiURL}Employees/CreateApplyLeave`, formData, { headers })
                    .then((response) => {
                        if (response.data.success === true) {
                            Swal.fire({
                                title: `<strong>${response.data.message}</strong>`,
                                icon: `${response.data.success === true ? 'success' : 'failed'}`,
                            });
                            this.closeRef.current.click();
                            this.setState({ leave_loader: false, });
                            this.resetForm();
                            this.GetList();
                            this.GetRemmainingLeaves();
                        } else {
                            Swal.fire({
                                title: `<strong>${response.data.message}</strong>`,
                                icon: `warning`,
                            });
                            this.setState({ leave_loader: false, });
                        }
                    })
                    .catch((error) => {
                        console.error("Error uploading file:", error);
                    });
            } else {
                this.setState({ leave_loader: false, });
                console.log("Form submission failed due to errors:", errors);
            }
        });
    };



    resetForm = () => {
        this.setState({
            employee_leave_id: 0,
            leave_type_id: '',
            employee_leave_from_date: '',
            employee_leave_to_date: '',
            employee_leave_document: '',
            employee_leave_reason: '',
            employee_leave_to_day_unit: '',
            employee_leave_from_day_unit: '',
            fileName: "",
            fileSize: "",
        });
    }

    handleSelectStatus = (selectedOption) => {
        this.setState({ employee_leave_status: selectedOption.value, });
    };
    handleSelectType = (selectedOption) => {
        this.setState({ filter_leave_type_id: selectedOption.value, });
    };



    resetemployee_leave_document = () => {
        // Clear the input value
        const employee_leave_document = document.getElementById("employee_leave_document");
        if (employee_leave_document) {
            employee_leave_document.value = null;
        }
        // Keep the same key for the input
        let randomString = Math.random().toString(36);
        this.setState({
            theInputKey: randomString,
        });
    };



    handleFileChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            const { name, size, type } = file;
            const fileSizeInMB = size / (1024 * 1024);
            const fileExtension = name.split(".").pop().toLowerCase();

            // Check file size
            if (fileSizeInMB > 10) {
                this.setState({
                    isValidFile: false,
                    errorMessage: "File size exceeds the maximum limit of 10 MB",
                });
                console.error("File size exceeds the maximum limit of 10 MB");
                return; // Exit function early
            }

            // Check if the file is an image or a PDF
            if (
                (type.startsWith("image/") && fileExtension.match(/(jpg|jpeg|png)$/)) ||
                (type === "application/pdf" && fileExtension === "pdf")
            ) {
                let newState = {
                    fileName: name,
                    fileSize: `${fileSizeInMB.toFixed(2)} MB`,
                    letterhead: [file],
                    isValidFile: true,
                    errorMessage: '', // Clear error message
                };

                if (type.startsWith("image/")) {
                    newState = {
                        ...newState,
                        selectedImage: URL.createObjectURL(file),
                    };
                } else {
                    newState = {
                        ...newState,
                        isValidPdfFile: true,
                    };
                }

                this.setState(newState);
            } else {
                this.setState({
                    isValidFile: false,
                    errorMessage: "Invalid file type or extension",
                });
                console.error("Invalid file type or extension");
            }
        }
    };

    GetLeaveInfo = (employee_leave_id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        axios.get(`${apiURL}Employees/GetLeaveInfo`, { params: { employee_leave_id: employee_leave_id,employee_id: this.state.employee_id }, headers }).then((response) => {
            const { data, success } = response.data;
            this.setState({ get_url: '' });
            if (success === true) {

                this.setState(
                    {
                        leave_type_id: data[0].leave_type_id,
                        employee_leave_from_date: data[0].employee_leave_from_date,
                        employee_leave_to_date: data[0].employee_leave_to_date,
                        employee_leave_document: data[0].employee_leave_document,
                        employee_leave_reason: data[0].employee_leave_reason,
                        employee_leave_from_day_unit: data[0].employee_leave_from_day_unit,
                        employee_leave_to_day_unit: data[0].employee_leave_to_day_unit,
                        get_url: data[0].employee_leave_document_url,
                    }
                )
            }
        });
    }


    handleCheckModalType = (CheckModalType, employee_leave_id) => {
        if (CheckModalType === 0) {
            // Reset form and set state
            this.resetForm();
            this.setState({
                check_modal_type: CheckModalType,
                submitAttempted: false,
                get_url: '',
                employee_leave_id: 0, // Resetting employee_leave_id to 0,
                errors: {},
            });
        }
        else if (CheckModalType === 1) {
            this.setState({
                check_modal_type: CheckModalType,
                employee_leave_id: employee_leave_id,
                submitAttempted: false,
                errors: {},
            });
            this.GetLeaveInfo(employee_leave_id);
        }
        else if (CheckModalType === 2) {
            this.setState({
                check_modal_type: CheckModalType,
                submitAttempted: false,
                errors: {},
            });
            this.GetLeaveInfo(employee_leave_id);
            this.GetLeaveLogs(employee_leave_id);
        }
    }

    handleDeleteImage = () => {
        this.setState({
            selectedImage: null,
            fileName: "",
            fileSize: "",

        });
        this.resetemployee_leave_document();
    };
    handleFilter = () => {
        this.GetList();
    }


    handleInputChange = (e) => {
        const errors = this.CheckValidation();
        const { name, value } = e.target;
        this.setState({ [name]: value });
        if (this.state.submitAttempted === true) {
            this.setState({ errors: errors });
        }
    }
    handleClearAll = () => {
        this.setState(
            {
                filter_leave_type_id: '',
                employee_leave_status: '',
                from_date: '',
                to_date: '',
                rows: [],
            },
            () => {
                this.GetList();
            }
        );
    };

    handleSelect = (selectedOption) => {
        const { value } = selectedOption;
        const errorMessage = this.validateNotEmpty('Leave Type', value);
        this.GetLeaveTypeInfo(value);
        this.setState({
            employee_leave_id: 0,
            leave_type_id: '',
            employee_leave_from_date: '',
            employee_leave_to_date: '',
            employee_leave_document: '',
            employee_leave_to_day_unit: '',
            employee_leave_from_day_unit: '',
            selectedImage: null,
            fileName: "",
            fileSize: "",
        });
        this.setState({
            leave_type_id: value,
            errors: {
                leave_type_id: errorMessage
            }
        });
    };
    handleSelectChange = (name, selectedOption) => {
        // this.resetForm();
        this.setState((prevState) => ({
            [name]: selectedOption.value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };

    render() {
        const { errorMessage, leave_log_rows, loadingList, LeaveRows, errors, half_day } = this.state;

        const statusOptions = [
            { value: '0', label: 'Pending' },
            { value: '2', label: 'Accepted' },
            { value: '1', label: 'Rejected' },
            { value: '3', label: 'Canceled' },
        ];

        let UnitOptions = [];

        if (half_day === 1) {
            UnitOptions = [
                { value: 'First Half', label: 'First Half' },
                { value: 'Second Half', label: 'Second Half' },
                { value: 'Full Day', label: 'Full Day' }
            ];
        } else {
            UnitOptions = [
                { value: 'Full Day', label: 'Full Day' }
            ];
        }
        const options = {
            chart: {
                height: 350,
                type: 'radialBar',
            },
            plotOptions: {
                radialBar: {
                    hollow: {
                        size: '62%',
                    }
                },
            },
            labels: ['Leaves'],
            colors: ['#00BFFF']
        };

        return loadingList === true ? (
            <center>Loading...</center>
        ) : (
            <div className='card'>
                <div className='card-body'>
                    <div class="card-header bg-light bg-gradient">
                        <h6 className="card-title mb-0 text-center" >LEAVES</h6>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-md-8'>
                            <div className='row'>
                                <div className='col-md-3'>
                                    <TextBox type="Date" id="from_date" name="from_date" label="From date" value={this.state.from_date} change={this.handleInputChange} />
                                </div>
                                <div className='col-md-3'>
                                    <TextBox type="Date" id="to_date" name="to_date" label="To date" value={this.state.to_date} change={this.handleInputChange} />
                                </div>
                                <div className='col-md-3'>
                                    <div>
                                        <label>Check Status</label>
                                    </div>
                                    <Select
                                        options={statusOptions}
                                        value={this.state.employee_leave_status ? statusOptions.find(option => option.value === this.state.employee_leave_status) : null}
                                        onChange={this.handleSelectStatus}
                                        hint={`Select Status`}
                                    />

                                </div>
                                <div className='col-md-3'>
                                    <div>
                                        <label>Check Leave Type</label>
                                    </div>
                                    <Select onChange={this.handleSelectType}
                                        hint={`Select Leave Type`}
                                        options={this.state.leave_type_row}
                                        value={this.state.filter_leave_type_id ? this.state.leave_type_row.find((option) => option.value === this.state.filter_leave_type_id) : null} // Add this line
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4 d-flex justify-content-around'>
                            <div>
                                <div>
                                    <label>Apply Filter</label>
                                </div>
                                <button type="button" onClick={this.handleFilter} className={`btn btn-info btn-label waves-effect waves-light ${(!this.state.employee_leave_status && this.state.from_date === '' && this.state.to_date === '' && !this.state.filter_leave_type_id) ? 'disabled' : ''}`}>
                                    <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                    Filter
                                </button>
                            </div>
                            <div>
                                <div>
                                    <label>Show All </label>
                                </div>
                                <button type="button"
                                    className={`btn btn-secondary btn-label right ${(!this.state.employee_leave_status && this.state.from_date === '' && this.state.to_date === '' && !this.state.filter_leave_type_id) ? 'disabled' : ''}`}
                                    onClick={this.handleClearAll}
                                >
                                    <i className=" ri-database-2-line label-icon align-middle fs-16 me-2"></i> Show All

                                </button>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-lg-12 mt-3">
                            <div style={{ float: "right" }}>
                                <button type="button" onClick={() => this.handleCheckModalType(0, 0)} className="btn btn-success btn-label waves-effect waves-light" data-bs-toggle="modal" data-bs-target="#myModal"><i className="bx bx-add-to-queue label-icon align-middle fs-16 me-2" />Apply Leave</button>
                                <div id="myModal" ref={this.modalRef} className="modal fade" tabIndex={-1} aria-labelledby="myModalLabel" aria-hidden="true" style={{ display: 'none' }}>
                                    <div className={`modal-dialog ${this.state.check_modal_type === 2 ? ('modal-xl') : "modal-lg"} `}>
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="myModalLabel">Leaves</h5>
                                                <button type="button" ref={this.closeRef} className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.resetForm}> </button>
                                            </div>
                                            <div className="modal-body">
                                                <form className="row">
                                                    <div className="col-md-12 mt-3">
                                                        <label htmlFor="leave_type_id" className="form-label">Select Leave Type:</label>
                                                        <Select onChange={this.handleSelect} isDisabled={this.state.check_modal_type === 2} hint={`Select Leave Type`} options={this.state.leave_type_row} value={this.state.leave_type_row.find(option => option.value === this.state.leave_type_id) || null} disabled={this.state.check_modal_type === 2} />
                                                        {errors.leave_type_id && <div className="text-danger">{errors.leave_type_id}</div>}
                                                    </div>

                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="employee_leave_from_date"><span>From Date</span></label>
                                                        <input
                                                            type="date"
                                                            min={this.state.past_date === 0 ? new Date().toISOString().split('T')[0] : null}
                                                            id="employee_leave_from_date"
                                                            name="employee_leave_from_date"
                                                            disabled={this.state.check_modal_type === 2}
                                                            value={this.state.employee_leave_from_date}
                                                            className='form-control'
                                                            onChange={this.handleInputChange}
                                                        />

                                                        {errors.employee_leave_from_date && <div className="text-danger">{errors.employee_leave_from_date}</div>}

                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="employee_leave_from_day_unit" className="form-label">Form Date Unit:</label>
                                                        <Select
                                                            id="employee_leave_from_day_unit"
                                                            name="employee_leave_from_day_unit"
                                                            value={UnitOptions.find(option => option.value === this.state.employee_leave_from_day_unit) || null}
                                                            onChange={(selectedOption) => this.handleSelectChange('employee_leave_from_day_unit', selectedOption)}
                                                            options={UnitOptions}
                                                            placeholder="Select from date unit"
                                                            required
                                                            isDisabled={this.state.check_modal_type === 2}
                                                        />
                                                        {errors.employee_leave_from_day_unit && <div className="text-danger">{errors.employee_leave_from_day_unit}</div>}

                                                    </div>


                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="employee_leave_to_date"><span>To Date</span></label>
                                                        <input type="Date" min={this.state.past_date === 0 ? new Date().toISOString().split('T')[0] : null} id="employee_leave_to_date" name="employee_leave_to_date" value={this.state.employee_leave_to_date} className='form-control' disabled={this.state.check_modal_type === 2} onChange={this.handleInputChange} />
                                                        {errors.employee_leave_to_date && <div className="text-danger">{errors.employee_leave_to_date}</div>}

                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="employee_leave_to_day_unit" className="form-label">TO Date Unit:</label>
                                                        <Select
                                                            id="employee_leave_to_day_unit"
                                                            name="employee_leave_to_day_unit"
                                                            value={UnitOptions.find(option => option.value === this.state.employee_leave_to_day_unit) || null}
                                                            onChange={(selectedOption) => this.handleSelectChange('employee_leave_to_day_unit', selectedOption)}
                                                            options={UnitOptions}
                                                            placeholder="Select to date unit"
                                                            required
                                                            isDisabled={this.state.check_modal_type === 2}
                                                        />
                                                        {errors.employee_leave_to_day_unit && <div className="text-danger">{errors.employee_leave_to_day_unit}</div>}
                                                    </div>
                                                    <div className="col-md-12 mt-3">
                                                        <label>Reason</label>
                                                        <textarea type='text' rows={3} className='form-control' id='employee_leave_reason' name='employee_leave_reason' value={this.state.employee_leave_reason} disabled={this.state.check_modal_type === 2} label='Reason' placeholder='Enter Reason' onChange={this.handleInputChange} />
                                                        {errors.employee_leave_reason && <div className="text-danger">{errors.employee_leave_reason}</div>}
                                                    </div>
                                                    <div className="col-md-12 mt-3">
                                                        <a href={`${this.state.get_url}`}
                                                            className={`${!this.state.get_url ? ('d-none') : ''} link-info link-offset-2 text-decoration-underline link-underline-opacity-25 link-underline-opacity-100-hover`}
                                                            style={{ marginTop: "10px", float: 'right' }}
                                                            target="_blank" rel="noopener noreferrer">
                                                            {/* <i className="ri-eye-fill label-icon align-middle fs-16 me-2" /> */}
                                                            View Uploaded Document
                                                        </a>
                                                    </div>
                                                    {this.state.check_modal_type !== 2 ? (
                                                        <div className="col-md-12 mt-3">
                                                            <div className="card-body">
                                                                <div>
                                                                    <label htmlFor="employee_leave_document" className="form-label">Attachment<span className='text-muted '>{this.state.required_document === 0 ? ("(...Optional)") : "(...Requested)"}</span></label>
                                                                    <input
                                                                        type="file"
                                                                        id="employee_leave_document"
                                                                        key={this.state.theInputKey || ""}
                                                                        onChange={this.handleFileChange}
                                                                        style={{ marginTop: "10px", display: "none" }}
                                                                        accept="image/jpeg, image/png, application/pdf"
                                                                        disabled={this.state.check_modal_type === 2}
                                                                    />

                                                                    <div className="d-flex justify-content-between mt-3">
                                                                        <label
                                                                            type="submit"
                                                                            className="btn btn-primary btn-label waves-effect waves-light"
                                                                            style={{ marginTop: "10px" }}
                                                                            htmlFor="employee_leave_document"
                                                                            disabled={this.state.check_modal_type === 2}
                                                                        >
                                                                            <i className="ri-file-line label-icon align-middle fs-16 me-2" />
                                                                            Chosse File
                                                                        </label>
                                                                        {this.state.leave_loader === false ? (
                                                                            this.state.check_modal_type === 0 ? (
                                                                                <button type="button" className="btn btn-success btn-label waves-effect waves-light" style={{ marginTop: "10px" }} onClick={() => this.handleSubmit(false)}>
                                                                                    <i className="ri-user-shared-2-line label-icon align-middle fs-16 me-2" />
                                                                                    Apply
                                                                                </button>

                                                                            ) : this.state.check_modal_type === 1 ? (
                                                                                <button type="button" className="btn btn-success btn-label waves-effect waves-light" style={{ marginTop: "10px" }} onClick={() => this.handleSubmit(true)}>
                                                                                    <i className="ri-user-shared-2-line label-icon align-middle fs-16 me-2" />
                                                                                    Update
                                                                                </button>
                                                                            ) : <></>
                                                                        ) :
                                                                            <>
                                                                                <button type="button" className="btn btn-success disabled" style={{ height: "50px" }}><i className="spinner-grow fs-15" /></button>

                                                                            </>
                                                                        }

                                                                    </div>

                                                                    <input
                                                                        type="file"
                                                                        id="employee_leave_document"
                                                                        key={this.state.theInputKey || ""}
                                                                        onChange={this.handleFileChange}
                                                                        style={{ marginTop: "10px", display: "none" }}
                                                                        accept="image/jpeg, image/png, application/pdf"
                                                                    />
                                                                    {errorMessage && <div className="text-danger">{errorMessage}</div>}
                                                                    <ul
                                                                        className="list-unstyled mb-0"
                                                                        id="dropzone-preview"
                                                                        style={{
                                                                            visibility:
                                                                                this.state.fileName === ""
                                                                                    ? "hidden"
                                                                                    : "visible",
                                                                        }}
                                                                    >
                                                                        <li
                                                                            className="mt-2 dz-processing dz-error dz-complete"
                                                                            id="dropzone-preview-list"
                                                                        >
                                                                            <div className="border rounded">
                                                                                <div className="d-flex p-2">
                                                                                    <div className="flex-shrink-0 me-3">
                                                                                        <div className="avatar-sm bg-light rounded">
                                                                                            {this.state.isValidExcelFile ? (
                                                                                                <i className="ri-alert-fill"
                                                                                                    style={{
                                                                                                        position: "absolute",
                                                                                                        color: "red",
                                                                                                        marginLeft: 20,
                                                                                                        marginTop: 10,
                                                                                                    }}
                                                                                                ></i>
                                                                                            ) : (
                                                                                                <div></div>
                                                                                            )}
                                                                                            <center>
                                                                                                <i className="ri-image-fill"
                                                                                                    style={{
                                                                                                        fontSize: 28,
                                                                                                        color: "green",
                                                                                                    }}
                                                                                                ></i>
                                                                                            </center>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="flex-grow-1">
                                                                                        <div className="pt-1">
                                                                                            <h5
                                                                                                className="fs-13 mb-1"
                                                                                                data-dz-name=""
                                                                                            >
                                                                                                {this.state.fileName}
                                                                                            </h5>
                                                                                            <p
                                                                                                className="fs-13 text-muted mb-0"
                                                                                                data-dz-size=""
                                                                                            >
                                                                                                <strong>{this.state.fileSize}</strong>
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="flex-shrink-0 ms-3 d-flex justify-content-center align-items-center">
                                                                                        <button
                                                                                            type='button'
                                                                                            data-dz-remove=""
                                                                                            onClick={this.handleDeleteImage}
                                                                                            className="btn btn-sm btn-outline-danger"
                                                                                        >
                                                                                            <i className="ri-delete-bin-line"></i>
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>) :
                                                        <div>
                                                            <div className="my-3">
                                                                <h5 className="modal-title" id="exampleModalPopoversLabel">Employee Leave Logs</h5>

                                                            </div>

                                                            <table className="table table-nowrap text-center mb-0">

                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th>Action Date</th>
                                                                        <th>Action By</th>
                                                                        <th>Leave Type</th>
                                                                        <th>From Date</th>
                                                                        <th>To Date</th>
                                                                        <th>Total Leave Days</th>
                                                                        <th>Reason</th>
                                                                        <th>Remark</th>
                                                                        <th>Status</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {leave_log_rows.map((row) => {
                                                                        var leave_obj = JSON.parse(row.leave_apply_object);
                                                                        return (
                                                                            <tr key={row.employee_leave_log_id}>
                                                                                <td>{formatDate(row.created_date)}</td>
                                                                                <td>{row.company_user_name[0].user_name}</td>
                                                                                <td>{leave_obj.leave_type_name}</td>
                                                                                <td>{formatDate(leave_obj.employee_leave_from_date)}</td>
                                                                                <td>{formatDate(leave_obj.employee_leave_to_date)}</td>
                                                                                <td>{leave_obj.employee_leave_days}</td>
                                                                                <td>{leave_obj.employee_leave_reason}</td>
                                                                                <td>{row.remark}</td>
                                                                                <td ><span className={`badge bg-${row.employee_leave_log_status_class}`}>{row.employee_leave_status_label}</span></td>
                                                                            </tr>
                                                                        )
                                                                    })}

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    }
                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6" >
                            <div className="card-header">
                                <h6 className="card-title mb-0 text-center">AVAILABLE LEAVES</h6>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    {loadingList ? (
                                        <center>Loading...</center>
                                    ) : (
                                        LeaveRows.map((LeaveRow) => (
                                            <div key={LeaveRow.leave_type_id} className="col-xl-4 col-md-4" style={{ height: "90px", width: "232px", marginBottom: "100px" }}>
                                                <div className="card card-animate overflow-hidden">
                                                    <div className="position-absolute start-0" style={{ zIndex: 0 }}>
                                                        <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 120" width={210} height={180}>
                                                            <style dangerouslySetInnerHTML={{ __html: "\n.s0 {\nopacity: .05;\nfill: var(--vz-info)\n}\n" }} />
                                                            <path id="Shape 8" className="s0" d="m189.5-25.8c0 0 20.1 46.2-26.7 71.4 0 0-60 15.4-62.3 65.3-2.2 49.8-50.6 59.3-57.8 61.5-7.2 2.3-60.8 0-60.8 0l-11.9-199.4z" />
                                                        </svg>
                                                    </div>
                                                    <div className="card-body" style={{ zIndex: 1 }}>
                                                        <div className="d-flex align-items-center">
                                                            <div className="flex-grow-1 ms-3">
                                                                <p className="text-uppercase fw-medium text-muted mb-3">{LeaveRow.leave_name}</p>
                                                                <div className="d-flex align-items-center mb-3">
                                                                    <h4 className="flex-grow-1 mb-0"><span className="counter-value" data-target={LeaveRow.remaining_leaves}>{LeaveRow.remaining_leaves}</span></h4>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div id={`chart-${LeaveRow.leave_type_id}`}>
                                                                    <ReactApexChart options={options} series={[LeaveRow.remaining_leaves_percentage]} type="radialBar" height={150} />
                                                                </div>
                                                                <div id="html-dist"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="card-header">
                                <h6 className="card-title mb-0 text-center" >LEAVE HISTORY</h6>
                            </div>
                            <div className="card-body">
                                <div data-simplebar style={{ maxHeight: "350px" }}>
                                    <ul className="list-group">
                                        {
                                            this.state.rows.map((row) => {
                                                return <li className="list-group-item">
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-grow-1">
                                                            <div className="d-flex">
                                                                <button type="button" data-bs-toggle="modal" data-bs-target="#myModal" onClick={() => this.handleCheckModalType(2, row.employee_leave_id)} className="btn btn-outline-info btn-sm btn-icon waves-effect waves-light"><i class=" ri-eye-fill fs-5"></i></button>
                                                                <div className="flex-shrink-0 ms-2">
                                                                    <h6 className="fs-14 mb-0">{row.heads_labels[0].concatenated_data}</h6>
                                                                    <small className="text-muted">{formatDate(row.employee_leave_from_date)} To {formatDate(row.employee_leave_to_date)}</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="flex-shrink-0 ">
                                                            <span className={`badge badge-label bg-${row.employee_leave_status_class}`}><i className="mdi mdi-circle-medium" /> {row.employee_leave_status_label}</span>

                                                        </div>
                                                        <div className="flex-shrink-0 ms-3" >
                                                            {row.employee_leave_status === 0 ? (<button type="button" onClick={() => this.handleDelete(row.employee_leave_id)} className="btn btn-outline-secondary btn-sm btn-icon waves-effect waves-light"><i class="ri-close-fill fs-5"></i></button>) : <></>}
                                                        </div>
                                                        <div className="flex-shrink-0 ms-3" >
                                                            {row.employee_leave_status === 0 ? (
                                                                <button type="button"
                                                                    data-bs-toggle="modal" data-bs-target="#myModal"
                                                                    onClick={() => this.handleCheckModalType(1, row.employee_leave_id)}
                                                                    ref={this.modalRef}
                                                                    className="btn btn-outline-primary btn-sm btn-icon waves-effect waves-light">
                                                                    <i class="ri-edit-box-line fs-5"></i></button>) : <></>}
                                                        </div>
                                                    </div>
                                                </li>
                                            })
                                        }

                                    </ul>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(Leaveapply);
